import { call, put, select } from 'redux-saga/effects';

import { selectors as globalSelectors } from '@elab/core/store/global';
import { actions as uiActions } from '@elab/core/store/ui';
import analytics from '@elab/core/utils/analytics';

import { actions } from '../..';
import { getWishlistCode } from '../../../../utils/wishlist/sagaHelpers';

export const addToWishlistLoggedInUserStrategiesCreator = addToWishlist => {
    /*
    if item is in wishlist - add
    otherwise - increase item quantity by 1
    [Applied on: KV, ICI]
    */
    function* addOne(productCode, egiftcard, analyticsData) {
        const wishlistCode = yield call(getWishlistCode);
        yield call(wrapperAddToWishlist, wishlistCode, productCode, egiftcard, analyticsData);
        yield call(analytics.handleAddToWishlist);
        yield put(actions.loadWishlist());
    }

    /* the only purpose of this wrapper
    is to not break saga tests */
    function* wrapperAddToWishlist(wishlistCode, productCode, egiftcard, analytics) {
        yield call(addToWishlist, wishlistCode, productCode, egiftcard, analytics);
    }

    /*
    it it is single wishlist - add item to wishlist
    otherwise - open popup to select wishlist
    [Applied on: MRN, WTC]
    */
    function* selectWishlist(productCode, egiftcard, analytics) {
        if (yield select(globalSelectors.multipleWishlistsEnabled)) {
            yield put(uiActions.openDialog({ name: 'select-wishlist-popup' }));
        } else {
            yield call(addOne, productCode, egiftcard, analytics);
        }
    }

    return { addOne, selectWishlist, wrapperAddToWishlist };
};
